import BannerSource from "@/api/BannerSource.js";


export const mainBanner = {

    state() {
        return {
            isLoading: true,
            desktopItems: [],
            mobileItems: []
        }
    },
    mutations: {
        setDesktopItems(state, data) {
            state.desktopItems = data;
        },
        setMobileItems(state, data) {
            state.mobileItems = data;
        },
    },
    actions: {
        async load({ state, dispatch, rootState }) {
            state.isLoading = true;
            if(rootState.isMobile){
                await  dispatch('getById', {
                    mutation: 'setMobileItems',
                    bannerId: 15,
                })
            }else{
                await dispatch('getById', {
                    mutation: 'setDesktopItems',
                    bannerId: 14,
                });
            }
            state.isLoading = false;
        },
        async getById({state, commit}, {mutation, bannerId}) {
                await this.$API.manager.getSource(BannerSource).list(bannerId).then(async (response) => {
                    await commit(mutation, response);
                }).catch(() => commit(mutation, []))
        }
    },
    namespaced: true
}
